import axios from 'axios'
import { downloadFile } from '../Functions/downloadFile'
import getFileNameFromAxiosResponse from '../Functions/getFileNameFromAxiosResponse'
import { useUser } from './useUser'

export default function useFbapiInstance() {
  const { user: fbUser } = useUser()

  const fbapi = import.meta.env.VITE_FBAPI!

  const api = axios.create({
    baseURL: fbapi,
  })

  api.interceptors.request.use(async (request) => {
    const token = await fbUser?.getIdToken().then((token) => token)
    if (import.meta.env.DEV) {
      console.log('fbuser', fbUser, 'token', token)

      // request.headers = { 'X-USER-EMAIL': fbUser?.email, ...request.headers } as any

      const sanitizedUrl = encodeURI(request.url || '')
      if (request.data) console.log('Making request to', sanitizedUrl, 'with data', request.data, request.headers)
      else if (request.params) console.log('Making request to', sanitizedUrl, 'with params', request.params, request.headers)
      else console.log('Making request to', sanitizedUrl, request.headers)
    }
    return request
  })

  api.interceptors.response.use(
    (response) => {
      const contentType = String(response.headers['content-type'] ?? '')

      if (contentType?.includes('application/octet-stream') || contentType?.includes('application/zip')) {
        const fileName = getFileNameFromAxiosResponse(response)
        if (import.meta.env.DEV) {
          console.log('Downloading file!')
          console.log('fileName', fileName)
        }
        downloadFile(response.data, fileName)
        if (import.meta.env.DEV) console.log('downloaded')
        return response
      } else {
        if (import.meta.env.DEV) console.log(`Received response from ${response.config.url}`, response)
        return response
      }
    },
    (error) => {
      console.error(`Error making request`, error)

      //checks if we have a custom error message from the API
      error.message = error.response?.data?.message ?? error.message
      return Promise.reject(error)
    }
  )

  return { api }
}
